import { createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(6),
      justifyContent: 'flex-start',
      paddingBottom: spacing(3),
      paddingLeft: spacing(3),
      paddingRight: spacing(3),
      paddingTop: 180,
    },
    contentContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
      justifyContent: 'center',
    },
    iconSection: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      justifyContent: 'center',
    },
    textSection: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      justifyContent: 'center',
      maxWidth: 500,
    },
    mainMessage: {
      color: colours.neutral[900],
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '28px',
      margin: 0,
      textAlign: 'center',
    },
    secondaryMessage: {
      color: colours.neutral[600],
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '20px',
      margin: 0,
      maxWidth: 445,
      textAlign: 'center',
    },
    supportLink: {
      color: colours.neutral[600],
      textDecoration: 'underline',
    },
    buttonRow: {
      alignItems: 'flex-start',
      display: 'flex',
      gap: spacing(3),
      justifyContent: 'flex-start',
    },
    returnButton: {
      minWidth: 'auto',
    },
    tryAgainButton: {
      minWidth: 'auto',
    },
  });
